<template>
  <v-container fluid>
    <v-card class="pa-5 mt-3">
      <v-toolbar flat>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            outlined
            dense
            :label="$t('search')"
            single-line
            hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn
            v-if="$store.getters.isInRole(110)"
            color="primary"
            dark
            class="mb-2"
            @click="dialog = true"
        >
          {{ $t("add") }}
          <v-icon> mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
      <data-table-component
          :headers="headers"
          :items="items"
          :search="search"
          :loading="loading"
          :show-footer="true"
      >

      </data-table-component>
    </v-card>

    <Dialog
        :onClose="close"
        :dialog="dialog"
        :editedItem="editedItem"
        :editedIndex="editedIndex"
        :valid="valid"
        :resetValidation="resetValidation"
        @refreshTable="refreshTable"
    />
    <confirm-dialog
        :openDialog="dialogDelete"
        :onClicked="deleteItemConfirm"
        :onClose="closeDelete"
    />
  </v-container>
</template>
<script>
import ConfirmDialog from "../../../components/ConfirmDialog.vue";
import Dialog from "./Dialog.vue";
import DataTableComponent from "../../../components/DataTableComponent.vue";

export default {
  components: {DataTableComponent, ConfirmDialog, Dialog},
  name: "VideoLibraryCourses",
  data() {
    return {
      loading: true,
      valid: true,
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      search: "",
      items: [],
      editedItem: {
        id: 0,
        title: null,
        order: null,
      },
      defaultItem: {
        id: 0,
        title: null,
        order: null,
      },
      resetValidation: 0,
    };
  },
  computed: {
    headers() {
      var list = [
        {text: this.$t("videoLibrary.order"), value: "order"},
        {text: this.$t("videoLibrary.courses.title"), value: "title"},
        {name: "created_at", text: this.$t("created_at"), value: "created_at", type: "date"},
      ];
      var actions = {
        text: "",
        value: "actions",
        templates: [],
      };
      if (this.$store.getters.isInRole(111)) {
        actions.templates.push({
          type: "btn",
          icon: "mdi-pencil",
          text: this.$t("edit"),
          click: this.editItem,
        });
      }
      if (this.$store.getters.isInRole(112)) {
        actions.templates.push({
          type: "btn",
          icon: "mdi-delete",
          text: this.$t("delete"),
          click: this.deleteItem,
          color: "red darken-2",
        });
      }
      list.push(actions);
      return list;
    },
  },
  created() {
    if (!this.$store.getters.isInRole(109)) {
      this.$router.push({name: "notauthorize"});
    }
    this.loading = true;
    this.refreshTable();
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      let deleteItem = this.items[this.editedIndex];
      this.$axios
          .delete("video_library/courses/" + deleteItem.id)
          .then(() => {
            this.refreshTable();
          });

      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.resetValidation += 1;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    refreshTable() {
      this.$axios
          .get("video_library/courses", {failureToast: true})
          .then((response) => {
            this.items = response.data.data;
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
};
</script>
